<template>
  <div>
    <h3 style="margin-left: 13px">View Administrative Requests</h3>
    <b-alert show>View administrative requests.</b-alert>

    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search" debounce="500"></b-form-input>
        <b-input-group-append>
          <b-button @click="clearFilter()">Clear</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-input-group class="filter-group">
        <b-form-select v-model="selectedTimePeriodId" :options="timePeriods" value-field="timePeriodId"
          text-field="description">
          <template slot="first">
            <!-- this slot appears above the options from 'options' prop -->
            <option :value="null">All Years</option>
          </template>
        </b-form-select>
      </b-input-group>

      <!-- This looks perfect, don't touch!!! -->
      <b-form-checkbox-group v-model="selectedStatuses" :options="statusDefinitions">
      </b-form-checkbox-group>
    </b-form>

    <b-table striped hover :items="filteredItems" :fields="fields" :per-page="perPage" :current-page="currentPage"
      sort-by="name" responsive show-empty>
      <template v-slot:cell(workload.timePeriod.description)="data">
        {{ data.item.workload.timePeriod.description }}
      </template>
      <!-- <template v-slot:cell(employee.fullName)="data">
        {{ data.item.supervisor.fullName }}
      </template> -->
      <template v-slot:cell(adminPercent)="data">
        {{ data.item.administrativePercent }}%
      </template>

      <template v-slot:cell(status)="data">
        {{ data.item.currentStatus.statusName }}
      </template>

      <template v-slot:cell(createdDate)="data">
        {{ data.item.createdDate | formatDateTime }}
      </template>

      <template v-slot:cell(requestedBy)="data">
        {{ data.item.workload.asurite.fullName }}
      </template>

      <template v-slot:cell(numberOfCourses)="data">
        <span v-if="data.item.numberOfCourses">{{ data.item.numberOfCourses }} courses</span>
        <span v-else>None</span>
      </template>

      <template v-slot:cell(stipend)="data">
        {{ data.item.stipend | trueOrFalse }}
      </template>

      <template v-slot:cell(details)="data">
        <router-link :to="{ name: 'adminRequestDetails', params: { id: data.item.id } }">Details</router-link>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import adminRequestApi from "../../api/administrativeRequests";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],

  data() {
    return {
      filter: "",
      currentPage: 1,
      perPage: 20,
      employee: "",
      requestedBy: "",
      adminPercent: 0.0,
      selectedStatuses: [],
      statusDefinitions: [],
      selectedTimePeriodId: null,
      approvedOnly: false,
      prefix: "",

      fields: [
        {
          key: "workload.timePeriod.description", // This HAS TO BE workload to get the info from!
          sortable: true,
          label: "Year"
        },
        { key: "status", sortable: true, label: "Status" },
        { key: "supervisor.fullName", sortable: true, label: "Supervisor" },
        { key: "adminPercent", sortable: true, label: "Total" },
        { key: "numberOfCourses", sortable: true, label: "Course Releases" },
        { key: "stipend", sortable: true, label: "Stipend" },
        { key: "createdDate", sortable: true, label: "Date Submitted" },
        { key: "requestedBy", sortable: true, label: "Requested By" },
        { key: "details", label: "" }
      ],
      adminRequests: []
    };
  },

  computed: {
    ...mapState({
      timePeriods: state => state.timePeriods.timePeriods,
      currentTimePeriod: state => state.status.currentTimePeriod,
      nextTimePeriod: state => state.status.nextTimePeriod,
      workloadFaculty: state => state.employees.workloadFaculty,
      workloadTypeDefinitions: state => state.workloads.workloadTypeDefinitions
    }),

    filteredItems: function () {
      var filtered = this.adminRequests;

      if (this.selectedTimePeriodId) {
        filtered = this.matchTimePeriod(filtered, this.selectedTimePeriodId);
      }

      if (this.selectedStatuses) {
        filtered = this.matchStatuses(filtered, this.selectedStatuses); // replace this with a filter that
      }

      filtered = this.search(filtered, this.filter);

      return filtered;
    },

    totalRows: function () {
      return this.filteredItems.length || 0;
    }
  },

  methods: {
    ...mapActions("timePeriods", ["getTimePeriods"]),

    // a and b are two record objects being compared, key is the key of the field being sorted on
    // return null to use the default sort-compare routine
    customSort(a, b, key) {
      // if (key === "address")
      // {
      // var addressA = a.address + ", " + a.city + " " + a.state + " " + a.zip;
      // var addressB = b.address + ", " + b.city + " " + b.state + " " + b.zip;
      // return addressA.localeCompare(addressB);
      // }
      // return null;
    },

    clearFilter: function () {
      this.filter = "";
      //localStorage.removeItem("filter");
    },
    matchTimePeriod(collection, timePeriodId) {
      if (timePeriodId != null) {
        return _.filter(collection, function (object) {
          if (object.workload) {
            return object.workload.timePeriodId === timePeriodId;
          }
          return false;
        });
      } else {
        return collection;
      }
    },

    matchStatuses(collection, selectedStatuses) {
      if (selectedStatuses.length) {
        return _.filter(collection, item => {
          // return true if selectedStatuses contains item currentStatus
          // i.e.
          // selectedStatuses === ["Approved", "Denied"]
          // item.currentStatus.name === "Approved"

          if (
            selectedStatuses.includes(
              item.currentStatus.administrativeRequestStatusDefinitionId
            )
          ) {
            return true;
          }
        });
      }
      return collection;
    },

    search(collection, text) {
      var that = this;
      return _.filter(collection, function (object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },

    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function (val) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function (memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    }
  },
  created() {
    this.getTimePeriods();

    adminRequestApi
      .getAllRequests()
      .then(response => {
        this.adminRequests = response.data;
      })
      .catch(function (error) {
        console.log(error);
      }),
      adminRequestApi.getStatusDefinitions().then(response => {
        this.statusDefinitions = _.map(response.data, item => {
          return {
            value: item.id,
            text: item.name
          };
        });
      });
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 1em 15px 0;
  max-width: 600px;
}
</style>
